import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Paragraph6FinancialDocument } from "../../../Paragraph6.types";

function getCreditNumberColumn() {
  return {
    header: "Erstellt aus",
    accessorFn: (row) => row.credit_number?.toString() ?? "",
    id: "credit_number",
    size: 120,
    enableResizing: false,
    filterVariant: "multi-select"
  } satisfies MRT_ColumnDef<Paragraph6FinancialDocument>;
}

export { getCreditNumberColumn };
